var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceColumnArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 158.495C0 158.495 20.3077 36.5621 0 0V334C22 286.359 0 175.321 44 175.321V158.495Z",
    fill: "#D0E2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4095 166.336C59.7462 166.715 59.7462 167.285 59.4095 167.664L45.7474 183.034C45.1365 183.721 44 183.289 44 182.37L44 151.63C44 150.711 45.1365 150.279 45.7474 150.966L59.4095 166.336Z",
    fill: "#D0E2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceColumnArrow);
export default __webpack_public_path__ + "static/media/price-column-arrow.5988b2ff84c0fa1fb029b887587e8399.svg";
export { ForwardRef as ReactComponent };